/**
 * resolveFlag — pure reader for a PostHog-style feature flag.
 *
 * Reads `key` from a posthog-like client and coalesces to `fallback` when the
 * client hasn't loaded flags yet, the value is undefined, or anything throws.
 * Kept free of the posthog-js import so it stays unit-testable in isolation.
 *
 * @param {object|null} client - posthog-like instance ({ __loaded, getFeatureFlag })
 * @param {string} key - feature flag key
 * @param {*} fallback - value to return when the flag can't be resolved (default false)
 */
export const resolveFlag = (client, key, fallback = false) => {
  try {
    if (!client || !client.__loaded || typeof client.getFeatureFlag !== 'function') {
      return fallback;
    }
    const value = client.getFeatureFlag(key);
    return value === undefined ? fallback : value;
  } catch (e) {
    return fallback;
  }
};
